/** Some routes are supposed to redirect the user to an outside site.
 * (eg. /find-a-dentist sends the user to detaquest.com) This function
 * checks the route and returns the new url if needed, null otherwise.
 */
export const getRouteOverride = () => {
  const siteName = getSiteName()
  const path = window.location.pathname.toLowerCase()
  if (path === '/find-a-dentist') {
    return siteName === 'vt'
      ? 'https://dentaquest.healthsparq.com/healthsparq/public/#/one/city=Montpelier&state=Vermont&postalCode=&country=US&insurerCode=DENTAQUEST_I&brandCode=DQSTANDARD&productCode=DQSVTB'
      : 'https://dentaquest.healthsparq.com/healthsparq/public/#/one/city=&state=North+Dakota&postalCode&country=US&insurerCode=DENTAQUEST_I&brandCode=DQSTANDARD&productCode=NORIDIAN'
  }
  if (path === '/telehealth') {
    return siteName === 'vt'
      ? 'https://vba.amwell.com/'
      : 'https://nbnd.amwell.com/'
  }
  return null
}

/** Some routes are aliases that are supposed to redirect the user to a more complicated url path.
 * This function checks the route for a vanity url
 * and returns the new path if needed, null otherwise.
 */
export const getRouteForAlias = () => {
  const siteName = getSiteName()
  const path = window.location.pathname.toLowerCase()
  const previousURL = document.referrer
  if (siteName === 'nd') {
    switch (path) {
    case '/turning65':
      if (!previousURL.endsWith('/almost65') && !previousURL.endsWith('/approaching65') && previousURL === '') {
        // conditional necessary due to '/turning65 also being a page name for the above aliases
        return '/utm_source%3Dnextblueweb%26utm_medium%3Ddirectmail%26utm_campaign%3Dt65cobrand%26utm_content%3Dblue%26utm_term%3D2'
        // contentful name: utm_source=nextblueweb&utm_medium=directmail&utm_campaign=t65cobrand&utm_content=blue&utm_term=2
      }
      return null
    case '/age65':
      return '/utm_source%3Dnextblueweb%26utm_medium%3Ddirectmail%26utm_campaign%3Dt65cobrand%26utm_content%3Dnon%26utm_term%3D2'
      // contentful name: utm_source=nextblueweb&utm_medium=directmail&utm_campaign=t65cobrand&utm_content=non&utm_term=2
    case '/medicare':
      return '/utm_source%3Dnextblueweb%26utm_medium%3Ddirectmail%26utm_campaign%3Dt65cobrand%26utm_content%3Dblue%26utm_term%3D5'
      // contentful name: utm_source=nextblueweb&utm_medium=directmail&utm_campaign=t65cobrand&utm_content=blue&utm_term=5
    case '/medicarend':
      return '/utm_source%3Dnextblueweb%26utm_medium%3Ddirectmail%26utm_campaign%3Dt65cobrand%26utm_content%3Dnon%26utm_term%3D5'
      // contentful name: utm_source=nextblueweb&utm_medium=directmail&utm_campaign=t65cobrand&utm_content=non&utm_term=5
    case '/approaching65':
      return '/turning65'
    case '/almost65':
      return '/turning65'
    case '/nearing65':
      return '/turning65'
    }
  } else if (siteName === 'vt') {
    switch (path) {
    case '/approaching65':
      return '/turning65'
    case '/almost65':
      return '/turning65'
    case '/nearing65':
      return '/turning65'
    }
  }

  return null
}

/** Returns the name of the site (vt or nd).
 * Must be updated manually if new route overrides are added. (internal overrides
 * such as /plans re-routing to /pages/plans-vt are handled in Azure's Rule Engine) */
const getSiteName = () => {
  const host = window.location.hostname.toLowerCase().replace('www.', '')
  switch (host) {
  case 'localhost':
    return parseInt(window.location.port, 10) === 3000 ? 'nd' : 'vt'
  case 'nextblue-nd-dev.azureedge.net':
  case 'next-blue.nd.azureedge.net':
  case 'nextblue-nd-phase2-dev.azureedge.net':
  case 'nextblue-nd-uat.azureedge.net':
  case 'nextbluend.com':
    return 'nd'
  case 'vermontblueadvantage.com':
  case 'nextblue-vt-uat.azureedge.net':
  case 'nextblue-vt-phase2-dev.azureedge.net':
  case 'nextblue-vt-dev.azureedge.net':
  case 'nextblue-vt.azureedge.net':
    return 'vt'
  default:
    if (host.includes('nd')) return 'nd'
    if (host.includes('vt')) return 'vt'
    throw new Error('unknown hostname')
  }
}
